import { alpha, Box, Stack, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import theme, { responsiveFontSize } from "themes/Theme";
import { getIconByStatus, getStatusBgColor } from "utils/common";
import { formateTransactionDate } from "utils/dateFormat";

export const usersColumn: GridColDef[] = [
  {
    field: "id",
    headerName: "#",
    width: 90,
    renderCell: (params: GridRenderCellParams) =>
      params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
  },
  {
    field: "name",
    headerName: "Name",
    minWidth: 200,
    flex: 1,
    renderCell: (params) => (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            ...styles.textStyle,
            color: theme.palette.primary.main,
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => {
            const userId = params.row.userId;
            if (userId) {
              window.location.href = `/admin/users/${userId}`;
            }
          }}
        >
          {`${params.row.firstName || ""} ${params.row.lastName || ""}`}
        </Typography>
      </Box>
    ),
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 200,
    flex: 1,
    renderCell: (params) => (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography sx={styles.textStyle}>{params.value}</Typography>
      </Box>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    renderCell: (params) => (
      <Stack direction={"row"} alignItems={"center"} sx={styles.height100}>
        <Box
          sx={{
            ...styles.statusContainer,
            height: "30px",
            padding: "5px 10px",
            borderRadius: "8px",
            border: `1px solid ${getStatusBgColor(params.value.toLowerCase())}`,
            backgroundColor: params.value
              ? alpha(getStatusBgColor(params.value.toLowerCase()), 0.2)
              : "",
          }}
        >
          <Typography
            sx={{
              ...styles.textStyle,
              color: getStatusBgColor(params.value.toLowerCase()),
            }}
          >
            {params.value}
          </Typography>
        </Box>
      </Stack>
    ),
  },
  {
    field: "role",
    headerName: "Role",
    minWidth: 120,
    renderCell: (params) => (
      <Stack direction={"row"} alignItems={"center"} sx={styles.height100}>
        <Typography
          sx={{ ...styles.textStyle, color: getUserColor(params.value) }}
        >
          {params.value}
        </Typography>
      </Stack>
    ),
  },
  {
    field: "createdAt",
    headerName: "Creation Date",
    minWidth: 200,
    renderCell: (params) => formateTransactionDate(params.value),
  },
];

const styles = {
  height100: {
    height: "100%",
  },
  statusContainer: {
    textTransform: "capitalize",
    alignSelf: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    fontWeight: 400,
    gap: 1,
  },
  textStyle: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
};

const getUserColor = (role: string) => {
  switch (role) {
    case "Admin":
      return theme.palette.custom.green;
    case "User":
      return theme.palette.custom.orange;
    case "Super Admin":
      return theme.palette.primary.main;
    default:
      return theme.palette.primary.main;
  }
};
